<template>
  <section id="register">
    <div class="container">
      <h1>Skapa konto</h1>
      <div class="form-field">
        <label for="">Företag</label>
        <input type="text" name="name" v-model="user.name" placeholder="Företag" value="">
      </div>
      <div class="form-field">
        <label for="">E-postadress</label>
        <input type="text" name="username" v-model="user.username" placeholder="E-post" value="">
      </div>
      <div class="form-field">
        <label for="">Lösenord</label>
        <input type="password" name="password" v-model="user.password" placeholder="Lösenord" value="">
      </div>
      <div class="form-field">
        <button @click="sendRegistrationData()">Skapa konto</button>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Register',
  props: {},
  data: function(){
    return {
      user: {
        name: '',
        username: '',
        password: '',
      }
    }
  },
  methods: {
    sendRegistrationData() {
      let self = this;
      let url = self.$parent.api_url + "/register";
      axios
        .post(
          url,
          {
            name: self.user.name,
            email: self.user.username,
            password: self.user.password,
          },
          {
            headers: {
              "Accept": "application/json",
              "Content-Type": "application/json"
            }
          }
        )
        .then(function(response) {
          self.$root.$router.push('login');
          self.$root.notification = 'Sådär, nu kan du logga in med din e-postadress och ditt lösenord.';
        })
        .catch(function(error) {
        });
    },
  }
}
</script>

<style scoped>

</style>
